/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.20.0
 */

import { ICreateInquiryTranslation } from '../../types';

export const initialCreateInquiryTranslation: ICreateInquiryTranslation = {
    start: {
        fields: {
            section: {
                label: '',
                placeholder: '',
                prompt: '',
            },
            topic: {
                label: '',
                placeholder: '',
                prompt: '',
            },

            description: {
                label: '',
                placeholder: '',
                prompt: '',
            },
            phone: {
                label: '',
                placeholder: '',
                prompt: '',
            },
            email: {
                label: '',
                placeholder: '',
                prompt: '',
            },

            file: {
                label: '',
                placeholder: '',
                prompt: '',
            },
        },

        title: '',
        subTitle: {
            ACCOUNT: '',
            MOBILE: '',
            CARD: '',
        },

        createBtn: '',
        createBtnValidation: {
            notValid: '',
            notAvailable: '',
            fileRequired: '',
        },
    },
    success: {
        fileAttachedWithErrors: '',
        inquiryId: '',
        inquiryList: '',
        title: '',
    },
    failure: {
        title: '',
    },
};
